import React from "react";

export default function FunnelIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <path
        d="M14.4144 3.59564C14.3375 3.41784 14.21 3.26658 14.0477 3.16068C13.8855 3.05477 13.6957 2.99891 13.5019 3.00002H2.50194C2.30839 3.0004 2.11912 3.05694 1.95708 3.16277C1.79503 3.26861 1.66719 3.41919 1.58904 3.59626C1.5109 3.77332 1.48581 3.96926 1.51684 4.1603C1.54786 4.35134 1.63365 4.52928 1.76381 4.67252L1.76881 4.67814L6.00194 9.19814V14C6.00189 14.181 6.05097 14.3586 6.14393 14.5139C6.2369 14.6692 6.37026 14.7963 6.5298 14.8818C6.68935 14.9672 6.86909 15.0078 7.04987 14.9991C7.23065 14.9904 7.40568 14.9329 7.55631 14.8325L9.55631 13.4988C9.69341 13.4074 9.80583 13.2837 9.88358 13.1384C9.96132 12.9932 10.002 12.831 10.0019 12.6663V9.19814L14.2357 4.67814L14.2407 4.67252C14.3722 4.52993 14.4588 4.35176 14.4897 4.16025C14.5206 3.96873 14.4945 3.77236 14.4144 3.59564ZM9.13819 8.66127C9.05169 8.75297 9.00303 8.87396 9.00194 9.00002V12.6663L7.00194 14V9.00002C7.00198 8.87305 6.95371 8.75083 6.86694 8.65814L2.50194 4.00002H13.5019L9.13819 8.66127Z"
        fill="#262626"
      />
    </svg>
  );
}
